"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.mediaObjectPropTypes = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

require("./media-object.less");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var mediaObjectPropTypes = {
  file: _propTypes["default"].shape({
    url: _propTypes["default"].string
  }).isRequired,
  title: _propTypes["default"].string,
  description: _propTypes["default"].string
};
exports.mediaObjectPropTypes = mediaObjectPropTypes;

var MediaObject = function MediaObject(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "MediaObject"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: "mediaObjectImage",
    src: "".concat(_lodash["default"].get(props.file, 'url'), "?w=800"),
    alt: props.title
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "caption"
  }, props.description));
};

MediaObject.propTypes = mediaObjectPropTypes;
MediaObject.defaultProps = {
  title: null,
  description: null
};
var _default = MediaObject;
exports["default"] = _default;